import React, { useState } from 'react';
import { TextField, Button, Link, Typography, Container, Card, CardContent, Alert, Box } from '@mui/material';
import axios from 'axios';
import { useOrg } from '../context/OrgContext';

const ForgotPassword = () => {
  const { name: companyName } = useOrg();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!email.trim()) {
      setError('Please enter your email address.');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/forgot-password`, {
        email: email.trim()
      });
      setSubmitted(true);
    } catch (err) {
      if (err.response?.status === 429) {
        setError(err.response.data?.message || 'Too many attempts. Please try again in a few minutes.');
      } else {
        setError('Something went wrong. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container maxWidth="xs">
      <Card sx={{ mt: 8, p: 2 }}>
        <CardContent>
          <Typography variant="h4" align="center">
            {companyName}
          </Typography>
          <Typography variant="h6" align="center" gutterBottom>
            Forgot Password
          </Typography>

          {submitted ? (
            <>
              <Alert severity="success" sx={{ mt: 2 }}>
                If that email exists, a reset link has been sent. Check your inbox
                (and spam folder) — the link expires in 1 hour.
              </Alert>
              <Box mt={2} textAlign="center">
                <Link href="/login" variant="body2">
                  Back to Login
                </Link>
              </Box>
            </>
          ) : (
            <form onSubmit={handleSubmit}>
              <Typography variant="body2" sx={{ mt: 1 }}>
                Enter the email address on your account and we'll send you a link
                to reset your password.
              </Typography>
              <TextField
                fullWidth
                label="Email Address"
                name="email"
                type="email"
                margin="normal"
                variant="outlined"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {error && (
                <Typography color="error" variant="body2">
                  {error}
                </Typography>
              )}
              <Button
                fullWidth
                variant="contained"
                color="primary"
                type="submit"
                sx={{ mt: 2 }}
                disabled={isLoading}
              >
                {isLoading ? 'Sending...' : 'Send Reset Link'}
              </Button>
              <Box mt={2} textAlign="center">
                <Link href="/login" variant="body2">
                  Back to Login
                </Link>
              </Box>
            </form>
          )}
        </CardContent>
      </Card>
    </Container>
  );
};

export default ForgotPassword;
